"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const Tooltip_1 = require("../../Tooltip");
const IconButton_module_css_1 = __importDefault(require("./IconButton.module.css"));
function getButtonStyle(size) {
    switch (size) {
        case "XSMALL":
            return IconButton_module_css_1.default.buttonXsmall;
        case "SMALL":
            return IconButton_module_css_1.default.buttonSmall;
        case "MEDIUM":
            return IconButton_module_css_1.default.buttonMedium;
        case "LARGE":
            return IconButton_module_css_1.default.buttonLarge;
    }
}
/**
 * Generic button with icon.  Shows actionMessage on click for messageTimeMillis.
 */
exports.IconButton = react_1.default.forwardRef(({ 
// TODO: fix prop type warnings
children, 
// eslint-disable-next-line react/prop-types
onClick, 
// eslint-disable-next-line react/prop-types
actionMessage, 
// eslint-disable-next-line react/prop-types
messageTimeMillis = 2000, 
// eslint-disable-next-line react/prop-types
size, 
// eslint-disable-next-line react/prop-types
label, 
// eslint-disable-next-line react/prop-types
color, }, ref) => {
    const [isMessageVisible, showMessage] = useBoolStateWithTimeout(messageTimeMillis);
    const onButtonClick = (0, react_1.useCallback)((event) => {
        if (actionMessage) {
            showMessage();
        }
        if (onClick) {
            onClick(event);
        }
    }, [actionMessage, onClick, showMessage]);
    // TODO: fix proptype warnings and this should go away
    /* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */
    const className = getButtonStyle(size);
    const colorStyle = color ? { backgroundColor: color } : undefined;
    return ((0, jsx_runtime_1.jsxs)("div", { className: IconButton_module_css_1.default.tooltipContainer, children: [isMessageVisible && ((0, jsx_runtime_1.jsx)("span", { className: IconButton_module_css_1.default.tooltip, children: (0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, { message: actionMessage, position: Tooltip_1.Position.LEFT }) })), (0, jsx_runtime_1.jsx)("div", { ref: ref, onClick: onButtonClick, className: className, style: colorStyle, role: "button", "aria-label": label, children: children })] }));
});
exports.IconButton.displayName = "IconButton";
function useBoolStateWithTimeout(millis) {
    const [state, setState] = (0, react_1.useState)(false);
    const [timeoutState, setTimeoutState] = (0, react_1.useState)(null);
    const setTrue = (0, react_1.useCallback)(() => {
        setState(true);
        const timeout = setTimeout(() => setState(false), millis);
        setTimeoutState(timeout);
    }, [millis]);
    const setFalse = (0, react_1.useCallback)(() => {
        setState(false);
        if (timeoutState) {
            clearTimeout(timeoutState);
        }
    }, [timeoutState]);
    return [state, setTrue, setFalse];
}
//# sourceMappingURL=IconButton.js.map